import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ProductsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/products", { params: toSnakeCase(params) });
  }

  fetch(id, params) {
    return securedAxiosInstance.get(`/products/${id}`, { params: toSnakeCase(params) });
  }

  approveProducts(productIds) {
    return securedAxiosInstance.post("/products/approve", toSnakeCase({ productIds }));
  }

  unApproveProducts(productIds) {
    return securedAxiosInstance.post("/products/unapprove", toSnakeCase({ productIds }));
  }

  matchProducts(productIds) {
    return securedAxiosInstance.post("/products/match", toSnakeCase({ productIds }));
  }

  unmatchProducts(productIds) {
    return securedAxiosInstance.post("/products/unmatch", toSnakeCase({ productIds }));
  }

  approveMatchProducts(productIds) {
    return securedAxiosInstance.post("/products/approve_match", toSnakeCase({ productIds }));
  }

  approveMatchPublishProducts(productIds) {
    return securedAxiosInstance.post("/products/approve_match_publish", toSnakeCase({ productIds }));
  }

  enableProducts(productIds) {
    return securedAxiosInstance.post("/products/enable", toSnakeCase({ productIds }));
  }

  disableProducts(productIds) {
    return securedAxiosInstance.post("/products/disable", toSnakeCase({ productIds }));
  }

  updateProductCategory(params) {
    return securedAxiosInstance.put("/products/category", toSnakeCase(params));
  }
}

export default new ProductsService();
